<template>
    <div class="manage-wrap">
        <div class="menu-wrap">
          
        </div>

        <!--设备操作记录-->
        <div class="record">
             <el-table
                :data="siteConfigList"
                border
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                :max-height="tableHeight"
                class="record-table"
                style="width: 100%">
                <el-table-column
                    prop="siteno"
                    width="120px"
                    label="站点编号">
                </el-table-column>

                 <el-table-column
                    prop="sitename"
                    label="站点名称">
                </el-table-column>

                <el-table-column
                    label="是否启用金额报警">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.amount_alarm"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="handleSwitch(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="min_amount"
                    label="最低金额">
                </el-table-column>

                <el-table-column
                    prop="amount_interval"
                    label="金额报警间隔">
                </el-table-column>

                <el-table-column
                    label="是否启用通讯报警">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.communication_alarm"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="handleSwitch(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="communication_interval"
                    label="通讯报警间隔">
                </el-table-column>

                <el-table-column
                    label="是否启用费用充值">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.enable_billing"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="handleSwitch(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="remark"
                    label="备注">
                </el-table-column>

                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <span @click="siteConfig(scope.row)" class="configbtn">设置</span>
                    </template>
                </el-table-column>

            </el-table>
           
        </div>

        <!-- 对话框 -->
        <el-dialog
            :visible.sync="siteDialog"
            :append-to-body='true'
            :modal="false"
            class="bill-dialog">

            <div slot="title">
                <span>站点设置</span>
            </div>
            <sitesetting :site="currentSite" v-if="siteDialog"/>
        </el-dialog>

    </div>
</template>
<script>

import {getSiteConfigList,updateSiteConfig} from "@api/siteconfig";

export default {
    name:"siteconfig",
    data(){
        return {
            siteDialog:false, // 设备管理对话框
            siteConfigList: [], // 设备管理记录
            tableHeight:600, // 表格高度

            currentSite:null, // 当前选中的站点
        }
    },
    components: {
        sitesetting:()=>import("./SiteSetting.vue"), // 设备操作
    },
    // components: { countTo },
    mounted(){
        // 监听数据刷新接口
        this.$bus.$on("updateSiteConfigRecord",this.getData);
        this.$nextTick(()=>{
            this.init();
        })
    },
    methods:{
        // 数据初始化
        init(){
            this.getData();
        },
        // 获取站点数据
        getData(){
            getSiteConfigList().then(res=>{
                if(res.status&&res.status==200){
                    let content=res.content;
                    // 设置分页信息
                    this.siteConfigList=content;
                }
            })
        },

        // 站点配置
        siteConfig(item){
            this.siteDialog=true;
            this.currentSite=item;
        },

        // 站点配置更新
        handleSwitch(item){
            updateSiteConfig(item).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"数据更新成功",
                        type:"success"
                    })
                }
            })
        }
        
    }
}
</script>

<style lang="scss">
.manage-wrap{
    .el-divider__text{
        background-color: #f5f8ff;
    }

    .record{
         // 单元格内容居中
        .record-table{
            table td,table th{
                text-align: center !important;
            }
            .RecordTime .cell{
                word-break:initial;
                white-space: pre;
            }
        }

        .configbtn{
            cursor: pointer;
            color: #4e84ff;
        }
    }
}
</style>